import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import history from "./utils/history";
import App from "./App";
import { AuthProvider } from "./contexts/authProvider";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./assets/fonts/stylesheet.css";
import "./index.css";
import { CarProvider } from "./contexts/carProvider";

const root = ReactDOM.createRoot(document.getElementById("DBRoot"));
root.render(
  <BrowserRouter
    history={history}
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <AuthProvider>
      <CarProvider>
        <App />
      </CarProvider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
